import { Card, CardBody, Col, Input, Label } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ListWithRadioTitle } from "../../../../Constants/Constants";
import { ListRadioData, ListWithRadioSubTitle } from "../../../../Data/UiKits/Lists";

const ListWithRadio = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={ListWithRadioTitle} span={ListWithRadioSubTitle} />
        <CardBody>
          <UL>
            {ListRadioData &&
              ListRadioData.map((item, index) => (
                <LI key={index}>
                  <Input className={`me-2 ${item.class}`} id={`firstRadio${index}`} type="radio" name="listGroupRadio" defaultChecked={item.check ? true : false} />
                  <Label className="mb-0" htmlFor={`firstRadio${index}`} check>
                    {item.text}
                  </Label>
                </LI>
              ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ListWithRadio;
